import { createReducer } from '@reduxjs/toolkit';
import {
    Task,
    listTasksRequest,
    listTasksSuccess,
    listTasksFailure,
    updateTasksRequest,
    updateTasksSuccess,
    updateTasksFailure,
    resetErrorRequest,
} from './actions';

export interface TaskState {
    tasks: Task[];
    loading: boolean;
    error: string | null;
}

const initialState: TaskState = {
    tasks: [],
    loading: false,
    error: null,
};

const taskReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(resetErrorRequest, (state) => {
            state.error = null;
        })
        .addCase(listTasksRequest, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(listTasksSuccess, (state, action) => {
            state.tasks = action.payload;
            state.loading = false;
        })
        .addCase(listTasksFailure, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(updateTasksRequest, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(updateTasksSuccess, (state, action) => {
            action.payload.removed_tasks.forEach((task_id: number) => {
                state.tasks = state.tasks.filter((el: Task) => el.id != task_id);
            });

            action.payload.tasks.map((task: Task) => {
                let found = false;
                state.tasks = state.tasks.map((el: Task) => {
                    if (el.id == task.id) {
                        found = true;
                        return {
                            ...el,
                            ...task,
                        }
                    }
                    return el;
                });
                if (!found) {
                    state.tasks.push(task);
                }
            });

            state.loading = false;
        })
        .addCase(updateTasksFailure, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
});

export default taskReducer;
